import React, { useState ,useRef} from "react";
import AgTableClient from "../../shared/AgTable/AgTableClient";
import HotelData from './sampleHotel.json'
import { getProcessedDefinition, getSubdomain } from "app/utils/generic.helper";
import { useRecoilState, useSetRecoilState } from "recoil";
import { tableSchema } from "app/config/States/agtable";
import { currentPDFData, userInfo } from "app/config/States/users";
import ToolParamInvoker from "app/shared/AgTable/HelperTools/ToolParamInvoker";
import sampleMyyatra from './sampleMyyatra.json';

const MyyatraTable = () => {
    const [rowData, setRowData] = useState(HotelData);
    const setRecoilPdfData = useSetRecoilState(currentPDFData);
    const [userDetails, setUserDetails] = useRecoilState(userInfo);
    const gridRef = useRef();
    const openSidebarRenderer = (params) => {
      console.log(params?.data?.["Updated Asset Link"], "params in openSidebarRenderer")
      params.api.openToolPanel("pdfRenderer", { paramData: params?.data?.["Final Invoice Link"] });
  };


    const columnDefs = [
        {
            headerName: "Invoice Link",
            field: "Invoice Link",
            filter: "agTextColumnFilter",
            //invoiceLink: "html.pdf",
            cellRenderer: ToolParamInvoker,
            formatType: "INVOICE",
            // cellRenderer: ToolParamInvoker,
            // formatProps: {},
            // ...handleCellRenderer(),
            cellRendererParams: (params) => {
                return {
                    label: "View Invoice",
                    handleClick: openSidebarRenderer,
                    //data: { pdfLink: params.data?.["Updated Asset Link"] }
                    data: params.data,
                };
            }
        },
        {
            headerName: "E-Invoice_link",
            field: "E-Invoice_link",
            filter: "agTextColumnFilter",
            //invoiceLink: "html.pdf",
            cellRenderer: ToolParamInvoker,
            formatType: "INVOICE",
            // cellRenderer: ToolParamInvoker,
            // formatProps: {},
            // ...handleCellRenderer(),
            cellRendererParams: (params) => {
                return {
                    label: "View Invoice",
                    handleClick: openSidebarRenderer,
                    //data: { pdfLink: params.data?.["Updated Asset Link"] }
                    data: params.data,
                };
            }
        },
        { field: "Booking_Reference", 
          headerName: "Booking_Reference",
          enableRowGroup: true,
          filter:'agTextColumnFilter'
        },
        { field: "Ticket_Number", 
          headerName: "Ticket_Number", 
          filter: "agTextColumnFilter", 
          enableRowGroup: true
        },
        { field: "Invoice_Date", 
          headerName: "Invoice_Date", 
          filter: "agDateColumnFilter",
          formatType:'DATE',
          enableRowGroup: true 
        },
        { field: "Booking_Generation", 
          headerName: "Booking Generation", 
          filter: "agDateColumnFilter", 
          enableRowGroup: true
        },
        { field: "Corporate", 
          headerName: "Corporate", 
          filter: "agTextColumnFilter", 
          enableRowGroup: true
        },
        { field: "SubEntity", 
          headerName: "SubEntity",
          filter: "agTextColumnFilter", 
          enableRowGroup: true
        },
        { field: "Hotel Name", 
          headerName: "Hotel Name", 
          filter: "agTextColumnFilter", 
          enableRowGroup: true
        },
        { field: "Traveller", 
          headerName: "Traveller", 
          filter: "agTextColumnFilter", 
          enableRowGroup: true
        },
        { field: "Total Nights", 
          headerName: "Total Nights", 
          enableRowGroup: true
        },
        
        { field: "Trip Start Date", 
          headerName: "Trip Start Date", 
          filter: "agDateColumnFilter",
          formatType:'DATE',
          enableRowGroup: true
         },
        { field: "Trip End Date", 
          headerName: "Trip End Date", 
          filter: "agDateColumnFilter", 
          formatType:'DATE',
          enableRowGroup: true
          },
        { field: "Base Fare", 
          headerName: "Base Fare", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
          },
        { field: "Other Taxes", 
          headerName: "Other Taxes", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
         },
        { field: "Gross Fare", 
          headerName: "Gross Fare", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
          },
        { field: "Tax", 
          headerName: "Tax", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
         },
        { field: "Corporate GSTIN", 
          headerName: "Corporate GSTIN",  
          filter: "agSetColumnFilter",
          enableRowGroup: true  
        },
        { field: "HotelGSTNumber", 
          headerName: "HotelGSTNumber", 
          filter: "agTextColumnFilter", 
          enableRowGroup: true
        },
        { field: "HotelEntityStateName", 
          headerName: "HotelEntityStateName", 
          filter: "agTextColumnFilter", 
          enableRowGroup: true
          },
        { field: "HotelIGSTPercentage", 
          headerName: "HotelIGSTPercentage", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
         },
        { field: "HotelCGSTPercentage", 
          headerName: "HotelCGSTPercentage", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
           },
        { field: "HotelSGSTPercentage", 
          headerName: "HotelSGSTPercentage", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
           },
        { field: "HotelIGSTAmount", 
          headerName: "HotelIGSTAmount", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
           },
        { field: "HotelCGSTAmount", 
          headerName: "HotelCGSTAmount", 
          filter: "agNumberColumnFilter", 
          enableRowGroup: true
          },
        { field: "HotelSGSTAmount", 
          headerName: "HotelSGSTAmount", 
          filter: true ,
          enableRowGroup: true
        },
        { field: "YATRAGSTNumber",
           headerName: "YATRA GST Number",
            filter: true ,
            enableRowGroup: true
          },
        { field: "GST Amount",
           headerName: "GST Amount", 
           filter: true ,
           enableRowGroup: true,
           filter: "agNumberColumnFilter", 
          },
        { field: "hotel_gstin", 
          headerName: "Hotel gstin", 
          filter: true ,
          enableRowGroup: true,
          //filter: "agTextColumnFilter", 
        },
        { field: "guest_gstin", 
          headerName: "Guest gstin", 
          filter: true ,
          enableRowGroup: true
        },
        // { field: "invoice_number", headerName: "Invoice number", filter: true },
        {
            headerName: "Invoice number",
            field: "invoice_number", // internal key
            filter: "agTextColumnFilter",
            enableRowGroup: true
            //cellRenderer: (params) => params.data?.["Invoice number"] || ""
          },
          
        { field: "invoice_date", 
          headerName: "Invoice date", 
          formatType:'DATE',
          enableRowGroup: true,
          filter: "agDateColumnFilter",
        },
        { field: "customer_gstin", 
          headerName: "Customer gstin", 
          filter: true ,
          enableRowGroup: true
        },
        { field: "invoice_type",
           headerName: "Invoice type", 
           filter: true ,
           enableRowGroup: true
          },
        { field: "taxable_amount", 
          headerName: "Taxable Amount", 
          filter: true ,
          enableRowGroup: true,
          filter: "agNumberColumnFilter",
        },
        { field: "cgst_amount",
           headerName: "cgst amount", 
           filter: true ,
           enableRowGroup: true,
           filter: "agNumberColumnFilter",
          },
        { field: "sgst_amount", 
          headerName: "sgst_amount", 
          filter: true ,
          enableRowGroup: true,
          filter: "agNumberColumnFilter",
        },
        { field: "igst_amount", 
          headerName: "igst_amount", 
          filter: true ,
          enableRowGroup: true,
          filter: "agNumberColumnFilter",
        },
        { field: "Total GST", 
          headerName: "Total GST", 
          enableRowGroup: true,
          filter: "agNumberColumnFilter",
        },
        { field: "vendor_gstin", 
          headerName: "vendor_gstin", 
          filter: "agTextColumnFilter",
          enableRowGroup: true
        },
        {field: "Irn", 
          headerName:'Irn', 
          filter:'agTextColumnFilter',
          enableRowGroup: true
         },
        {field:'996311_cgst_amount',
           headerName:'HSN 996311_cgst_amount',
           filter:'agNumberColumnFilter',
           enableRowGroup: true
          },
        {field:'996311_sgst_amount',
           headerName:'HSN 996311_sgst_amount',
           filter:'agNumberColumnFilter',
           enableRowGroup: true
          },
    //     {
    //       headerName: "Invoice Link",
    //       field: "Final Invoice Link",
    //       filter: "agTextColumnFilter",
    //       //invoiceLink: "html.pdf",
    //       cellRenderer: ToolParamInvoker,
    //       formatType: "INVOICE",
    //       // cellRenderer: ToolParamInvoker,
    //       // formatProps: {},
    //       // ...handleCellRenderer(),
    //       cellRendererParams: (params) => {
    //           return {
    //               label: "View Invoice",
    //               handleClick: openSidebarRenderer,
    //               //data: { pdfLink: params.data?.["Updated Asset Link"] }
    //               data: params.data,
    //           };
    //       }
    //   },
      ];

      const getProcessedDefinitions = () => {
        

        return getProcessedDefinition(
            columnDefs,
            "CLIENT",
            setRecoilPdfData,
            userDetails || {}
        );
    };
      
console.log(columnDefs,"columnDefs")
console.log(rowData,"rowData")
  return (
    <div>
        <div style={{ height: "100vh" }}>
        <AgTableClient 
          rowData={sampleMyyatra} 
          //columnDefs={columnDefs}
          columnDefs={getProcessedDefinitions()}
          groupPanel
          pdfV2
          pdfDataKey="Invoice Link"
          ref={gridRef}
          />
    </div>
    </div>
  );
};

export default MyyatraTable;





